var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.componentName,{key:_vm.hash,tag:"component",attrs:{"user-email":_vm.email},on:{"login-link":_vm.changeHash,"email-redirect":_vm.emailRedirect,"loading-start":function($event){return _vm.$emit('loading-start')},"loading-end":function($event){return _vm.$emit('loading-end')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }